// --------------------------------------------------------------------------------
// TimeWarp is responsible for skipping over sections of the track where the avatar
// does not move a significant distance in a given amount of time. E.g. a lunch break.
// For certain activity types, these breaks can be quite common and undesirable.
// An activity may specify "stopIntervals" which are pairs of start and end times.
// If the viewer's clock ends up in one of these intervals, it will jump to the end.
// This may mean that "squiggly" parts of the trail may pop in when jumping time,
// but in practice the amount of movement is so small it is not noticeable.
// --------------------------------------------------------------------------------
export default class TimeWarp {
    update(store) {
        const state = store.getState();
        const clockTime = state.clock.time;
        const activeId = state.tracks.activeTrack;
        const intervals = state.scene.activities[activeId].stopIntervals;
        // If the active track is inside a stop interval, jump to the time when it starts moving again
        // @NOTE: Not jumping while paused serves two purposes: Photos pause and set time while displaying, and scrubbing pauses while active
        if (intervals && state.clock.playing) {
            const interval = intervals.find(i => i.start <= clockTime && i.end >= clockTime);
            if (interval) {
                store.dispatch({ type: 'SET_TIME', time: interval.end });
            }
        }
    }
}
